import { jsPDF } from "jspdf";
import React, { useRef, useState } from "react";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import { Grid, Icon } from "@mui/material";
import pxToRem from "assets/theme/functions/pxToRem";
import EmpleadoLayout from "components/LayoutContainers/EmpleadoLayout";
import boxShadows from "assets/theme/base/boxShadows";
import PdfHeader from "../components/pdfHeader";
import { textosPliego } from "./textosPliego";

const PliegoGeneral = () => {
  const currentYear = new Date().getFullYear();
  const documentsRef = useRef(null);
  const { lg } = boxShadows;

  const [editable, setEditable] = useState(true);

  const handleGeneratePdf = async () => {
    setEditable(false);
    const document = documentsRef.current.childNodes[0];
    const doc = new jsPDF({
      format: "a4",
      unit: "px",
      orientation: "portrait",
      hotfixes: ["px_scaling"],
    });

    await doc.html(document, {
      margin: [50, 0, 50, 0],
      callback(doc) {
        doc.save(`Pliego General.pdf`);
      },
    });
    setEditable(true);
  };

  return (
    <EmpleadoLayout>
      <SoftBox
        p={2}
        display="flex"
        alignItems="center"
        flexDirection="column"
        minHeight="100vh"
        height="100%"
      >
        <div ref={documentsRef}>
          <SoftBox
            sx={{
              position: "relative",
              overflow: "hidden",
              width: "794px",
              backgroundColor: "#ffffff",
              boxShadow: lg,
              px: 6,
            }}
            pb={5}
          >
            {/* ACA VA TODO EL CODIGO */}
            <PdfHeader />
            <SoftBox px={1}>
              <SoftTypography
                variant="h6"
                fontWeight="bold"
                sx={{
                  textDecorationLine: "underline",
                }}
                textAlign="center"
              >
                CONCURSO DE PRECIOS UPrO-{currentYear} <br />
                PLIEGO GENERAL DE CONDICIONES

              </SoftTypography>
            </SoftBox>
            {textosPliego.map((articulo, index) => {
              return (
                <SoftBox key={index} pb={3}>
                  <SoftTypography
                    variant="h6"
                    fontWeight="bold"
                    sx={{
                      textDecorationLine: "underline",
                    }}
                    textAlign="center"
                  >
                    {articulo.encabezado}
                  </SoftTypography>
                  <SoftTypography variant="h6" fontWeight="bold">
                    {articulo.articulo}
                  </SoftTypography>
                  {articulo.texto.map((texto, i) => {
                    return (
                      <p key={i} style={{ fontSize: "0.9rem", paddingBottom: 10 }}>
                        {texto}
                      </p>
                    );
                  })}
                </SoftBox>
              );
            })}
            <SoftBox display="flex" justifyContent="end" textAlign="center" mt={6}>
              <SoftBox lineHeight={1}>
                <div style={{ borderBottom: "1px solid #344767" }} />
                <SoftTypography variant="caption">
                  Jessica B. Zafra<br />
                  Subdirectora de Compras y Contrataciones  <br />
                  FUNDACIÓN UPrO
                </SoftTypography>
              </SoftBox>
            </SoftBox>
          </SoftBox>
        </div>
        <SoftBox
          variant="contained"
          bgColor="white"
          p={2}
          style={{
            position: "fixed",
            bottom: "1.5rem",
            right: "1.5rem",
            zIndex: 1000,
            boxShadow:
              "inset 0rem 0rem 0.0625rem 0.0625rem rgb(255 255 255 / 90%), 0rem 1.25rem 1.6875rem 0rem rgb(0 0 0 / 5%)",
            borderRadius: "16px",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            backdropFilter: `saturate(200%) blur(${pxToRem(30)})`,
          }}
        >
          <Grid container spacing={2} justifyContent="flex-end" id="button">
            <Grid item>
              <SoftButton variant="gradient" color="error" onClick={handleGeneratePdf}>
                <Icon fontWeight="bold">picture_as_pdf</Icon>
                &nbsp;&nbsp;Descargar PDF
              </SoftButton>
            </Grid>
          </Grid>
        </SoftBox>
      </SoftBox>
    </EmpleadoLayout>
  );
};

export default PliegoGeneral;